export enum Profile {
  MANAGER = "MANAGER",
  OPERATIONAL = "OPERATIONAL",
  SUPERVISOR = "SUPERVISOR",
  FREELANCER = "FREELANCER"
}
